import { render, staticRenderFns } from "./BillingMassSubmitModal.vue?vue&type=template&id=56848ece&scoped=true&"
import script from "./BillingMassSubmitModal.vue?vue&type=script&lang=js&"
export * from "./BillingMassSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./BillingMassSubmitModal.vue?vue&type=style&index=0&id=56848ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56848ece",
  null
  
)

export default component.exports